import { defineStore } from 'pinia';

import useConfigQuery from '@modules/config/queries/useConfigQuery';
import { watchImmediate } from '@vueuse/core';

import useLogoStore from './useLogoStore';

const useConfigStore = defineStore('config', () => {
  const { setFavicon } = useLogoStore();

  const { data: config } = useConfigQuery();

  watchImmediate(config, (newValue) => {
    if (newValue) {
      setFavicon(newValue.favicon);
    }
  });

  return {
    config,
  };
});

export default useConfigStore;
